import * as React from 'react';

type IconInformeTecnicoProps = React.SVGProps<SVGSVGElement>;

export const IconInformeTecnico: React.FC<IconInformeTecnicoProps> = (props) => (
	<svg
		width={29}
		height={30}
		viewBox="0 0 29 30"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<rect
			x="0.611099"
			y="-0.000732422"
			width="23.3335"
			height="27.7788"
			rx="2.22227"
			fill="#EBF8F0"
		/>
		<path
			d="M5.05489 4.44458L19.4995 4.44458"
			stroke="#FFA692"
			stroke-width="1.97984"
			stroke-linecap="round"
		/>
		<path
			d="M5.05489 8.88989L19.4995 8.88989"
			stroke="#FFA692"
			stroke-width="1.97984"
			stroke-linecap="round"
		/>
		<path
			d="M5.05489 13.3352L13.9439 13.3352"
			stroke="#FFA692"
			stroke-width="1.97984"
			stroke-linecap="round"
		/>
		<ellipse
			cx="20.6111"
			cy="22.2226"
			rx="7.77785"
			ry="7.77805"
			fill="#7EAE90"
		/>
		<path
			d="M17.278 22.7154L19.3993 24.4439L23.9448 19.9993"
			stroke="#EBF8F0"
			stroke-width="2.22227"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
